import React from 'react'

export default function Page() {
  return (
    <div className="max-width-90p">
      {/* <div className="hero"> */}
      <h1>Eleva Tu Pasión por el Rugby</h1>
      <p>Bienvenido a la casa del rugby en Paraguay. Nuestro compromiso es llevarte más cerca del juego que amas. Desde emocionantes partidos hasta perfiles de equipos y jugadores destacados, aquí encontrarás todo lo que necesitas para sumergirte en el mundo del rugby.</p>

      <div className="cta-buttons">
        <a className="cta-button max-width-33p" href="/">
          <div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className=" text-white h-6 w-6 mb-2 opacity-75"><polyline points="22 12 16 12 14 15 10 15 8 12 2 12"></polyline><path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path></svg>
            </div>
            <h2>Torneos en curso</h2>
            <p>Explora los emocionantes torneos de rugby que están sucediendo ahora mismo.</p>
          </div>
        </a>

        <a className="cta-button max-width-33p" href="/anteriores">
          <div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className=" text-white h-6 w-6 mb-2 opacity-75"><polyline points="22 12 16 12 14 15 10 15 8 12 2 12"></polyline><path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path></svg>
            </div>
            <h2>Torneos anteriores</h2>
            <p>Revive la emoción de los torneos pasados y descubre momentos memorables.</p>
          </div>
        </a>

        <a className="cta-button max-width-33p" href="/blog">
          <div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className=" text-white h-6 w-6 mb-2 opacity-75"><polyline points="22 12 16 12 14 15 10 15 8 12 2 12"></polyline><path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path></svg>
            </div>
            <h2>Blog</h2>
            <p>Sumérgete en nuestro apasionante blog y mantente informado sobre el mundo del rugby.</p>
          </div>
        </a>
      </div>

      <div className="cta-buttons">
        <a className="cta-button max-width-33p" href="https://www.instagram.com/rugby_data_paraguay/" target="_blank">
          <div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className=" text-white h-6 w-6 mb-2 opacity-75"><polyline points="22 12 16 12 14 15 10 15 8 12 2 12"></polyline><path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path></svg>
            </div>
            <h2>Instagram</h2>
            <p>Síguenos en Instagram para estar al tanto de las últimas novedades y contenido exclusivo.</p>
          </div>
        </a>

        <a className="cta-button max-width-33p" href="https://chat.whatsapp.com/CxOlZsPcKndFLs0W2E8fUP" target="_blank">
          <div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className=" text-white h-6 w-6 mb-2 opacity-75"><polyline points="22 12 16 12 14 15 10 15 8 12 2 12"></polyline><path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path></svg>
            </div>
            <h2>Comunidad de WhatsApp</h2>
            <p>Únete a nuestra comunidad en WhatsApp y conecta con otros amantes del rugby.</p>
          </div>
        </a>

        <a className="cta-button max-width-33p" href="#">
          <div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className=" text-white h-6 w-6 mb-2 opacity-75"><polyline points="22 12 16 12 14 15 10 15 8 12 2 12"></polyline><path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path></svg>
            </div>
            <h2>Colaboradores!</h2>
            <p>Descubre a nuestros apasionados colaboradores y su contribución al rugby paraguayo.</p>
          </div>
        </a>
      </div>



      {/* </div> */}

    </div>
  )
}